
import { Component, ChangeDetectionStrategy, inject, signal } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  templateUrl: './forgot-password.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, RouterLink, CommonModule],
})
export class ForgotPasswordComponent {
  private authService = inject(AuthService);
  
  resetForm: FormGroup;
  isLoading = signal(false);
  message = signal<{ type: 'success' | 'error', text: string } | null>(null);

  constructor() {
    const fb: FormBuilder = inject(FormBuilder);
    this.resetForm = fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  async onSubmit(): Promise<void> {
    if (this.resetForm.invalid) return;

    this.isLoading.set(true);
    this.message.set(null);

    const email = this.resetForm.value.email;
    const result = await this.authService.sendPasswordResetEmail(email);

    this.isLoading.set(false);

    if (result.success) {
      this.message.set({ 
        type: 'success', 
        text: 'ระบบได้ส่งลิงก์สำหรับรีเซ็ตรหัสผ่านไปที่อีเมลของคุณแล้ว กรุณาตรวจสอบกล่องจดหมาย (Check your inbox)' 
      });
      this.resetForm.reset();
    } else {
      this.message.set({ 
        type: 'error', 
        text: result.error || 'เกิดข้อผิดพลาดในการส่งอีเมล' 
      });
    }
  }
}
